export default {
  eventListPage: {
    city: {
      cityCategoryHorizontalListTitle:
        'Workshops und Kurse in {city} entdecken',
    },
    category: {
      categoryCitiesHorizontalListTitle:
        '{category} Erlebnisse in Deiner Stadt entdecken',
    },
    teamEventSlugPrefix: 'teamevent',
    kitsTitle: '{category} für zu Hause',
  },
}
